import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

let prevPathName = null;

const Refocus = ({ children }) => {
  // component resets the focus and scroll after moving to a new page
  const history = useHistory();

  const ref = useRef(null);

  useEffect(() => {
    history.listen(
      ({ pathname }) => {
        // don't refocus if only the query params have changed
        if (pathname !== prevPathName) {
          ref.current.focus();

          // Scroll to top of page
          document.querySelector('body').scrollTo(0, 0);

          prevPathName = pathname;
        }
      },
      [prevPathName]
    );
  });

  return (
    <div ref={ref} tabIndex={-1} style={{ outline: 'none' }}>
      {children}
    </div>
  );
};

Refocus.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Refocus;
